import React, { useMemo, useState } from 'react'
import { App, Button, Card, Form, Input, Space, Typography } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { useLocation, useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'
import { useBnszcMutation } from '../../store/dianshangtaizhangApi'
import { useShangpingdingdanAddMutation } from '../../store/ReactWebSiteApi'

const { Title, Text } = Typography

function H5sysGoodsNewUser() {
    const { message } = App.useApp()
    const navigate = useNavigate()
    const { state } = useLocation()
    const [loading, setLoading] = useState(false)
    const [submitAdd] = useBnszcMutation()
    const [orderAdd] = useShangpingdingdanAddMutation()

    const goodsInfo = useMemo(
        () => ({
            eowg_id: state?.eowg_id || '',
            eowg_name: state?.eowg_name || '',
            eowgg_id: state?.eowgg_id || '',
            eowgg_name: state?.eowgg_name || '',
            eowg_shuoming: state?.eowg_shuoming || '',
            eowgt_id: state?.eowgt_id || '',
            eowgt_name: state?.eowgt_name || '',
            eowgts_id: state?.eowgts_id || '',
            eowgts_name: state?.eowgts_name || '',
        }),
        [state]
    )

    const onFinish = async (values) => {
        if (!goodsInfo.eowg_id) {
            message.error('商品信息丢失，请从商品列表重新进入')
            return
        }

        setLoading(true)
        try {
            const createUserRes = await submitAdd({
                qy_name: values.qy_name,
                qy_state: '1',
                yh_phone: values.yh_phone,
                yh_name: values.yh_name,
                yh_qx: '管理',
                yh_juese: '1',
                yh_state: '1',
            })

            if (createUserRes?.data?.Status !== 'success') {
                message.error(`注册失败！${createUserRes?.data?.Message || ''}`)
                return
            }
            console.log(goodsInfo);
            
            const orderRes = await orderAdd({
                dd_eowg_id: goodsInfo.eowg_id,
                dd_eowg_name: goodsInfo.eowg_name,
                dd_eowgg_id: goodsInfo.eowgg_id,
                dd_eowgg_name: goodsInfo.eowgg_name,
                dd_byxkh_id: '',
                dd_byxkh_name: values.dd_byxkh_name,
                dd_xf_date: dayjs().format('YYYY-MM-DD'),
                dd_dq_date: dayjs().add(1, 'month').format('YYYY-MM-DD'),
                dd_xf_amount: '1',
                dd_xf_num: '',
                dd_content: values.dd_content || '',
                dd_uid: localStorage.getItem('eu_id'),
                dd_uname: localStorage.getItem('eu_name'),
                dd_qy_id: '',
                dd_qy_name: values.qy_name,
                dd_database: goodsInfo.eowg_shuoming,
                dd_eowgt_id: goodsInfo.eowgt_id,
                dd_eowgt_name: goodsInfo.eowgt_name,
                dd_eowgts_id: goodsInfo.eowgts_id,
                dd_eowgts_name: goodsInfo.eowgts_name,
            })

            if (orderRes?.data?.Status === 'success') {
                message.success('新增成功！')
                navigate('/H5sysGoodsList', { replace: true })
            } else {
                message.error(`新增失败！${orderRes?.data?.Message || ''}`)
            }
        } finally {
            setLoading(false)
        }
    }

    return (
        <div style={{ minHeight: '100vh', background: '#f5f6f8' }}>
            <div
                style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 10,
                    background: '#fff',
                    padding: '12px 14px',
                    borderBottom: '1px solid #f0f0f0',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                }}
            >
                <ArrowLeftOutlined style={{ fontSize: 18 }} onClick={() => navigate('/H5sysGoodsList')} />
                <Title level={5} style={{ margin: 0 }}>
                    新增企业用户
                </Title>
            </div>

            <div style={{ padding: 12 }}>
                <Card variant="borderless" style={{ borderRadius: 10, marginBottom: 10 }}>
                    <Space direction="vertical" size={2}>
                        <Text type="secondary">当前商品</Text>
                        <Text strong>{goodsInfo.eowg_name || '-'}</Text>
                    </Space>
                </Card>

                <Card variant="borderless" style={{ borderRadius: 10 }}>
                    <Form layout="vertical" onFinish={onFinish}>
                        <Form.Item label="企业全称" name="dd_byxkh_name" rules={[{ required: true, message: '请填写企业全称' }]}>
                            <Input placeholder="请输入企业全称" />
                        </Form.Item>
                        <Form.Item label="企业简称" name="qy_name" rules={[{ required: true, message: '请填写企业简称' }]}>
                            <Input placeholder="请输入企业简称" />
                        </Form.Item>
                        <Form.Item label="管理员姓名" name="yh_name" rules={[{ required: true, message: '请填写管理员姓名' }]}>
                            <Input placeholder="请输入管理员姓名" />
                        </Form.Item>
                        <Form.Item
                            label="管理员手机号"
                            name="yh_phone"
                            rules={[
                                { required: true, message: '请填写管理员手机号' },
                                { pattern: /^1[3-9]\d{9}$/, message: '请输入正确手机号' },
                            ]}
                        >
                            <Input placeholder="请输入管理员手机号" />
                        </Form.Item>
                        <Form.Item label="订单备注" name="dd_content">
                            <Input placeholder="请输入订单备注（选填）" />
                        </Form.Item>
                        <Form.Item style={{ marginBottom: 0 }}>
                            <Button type="primary" htmlType="submit" block loading={loading}>
                                提交
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
            </div>
        </div>
    )
}

export default H5sysGoodsNewUser
